import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axiosInstance";
import moment from "moment";
import { useAuth } from "../../AuthContext";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import OrgnizerEventManagementTabs from "./OrgnizerEventManagementTabs";
import InviteModal from "./InviteModal";
import EditEvent from "./EditEvent";

const OrganizerEventDetail = () => {
  const { t, i18n } = useTranslation();
  const languageDirection = i18n.language === "ar" ? "rtl" : "ltr";
  const navigate = useNavigate();
  const [event, setEvents] = useState([]);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);
  const { userId } = useAuth();
  toast.dismiss();
  const [showModal, setShowModal] = useState(false);
  const [showEditPanel, setShowEditPanel] = useState(false);

  const { eventId } = useParams();
  const [eventDetail, setEventDetail] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);

  useEffect(() => {
    const fetchEventDetail = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/v1/organizers/events/${eventId}`
        );
        console.log("Event Detail: ", response.data);
        setEventDetail(response.data);
      } catch (error) {
        console.error("Error fetching event detail:", error);
        toast.error("فشل في تحميل تفاصيل الحدث");
      }
    };

    fetchEventDetail();
  }, [eventId]);

  const handleDelete = async (eventId) => {
    const isConfirmed = window.confirm("هل أنت متأكد أنك تريد حذف هذا الحدث؟");

    if (!isConfirmed) {
      return;
    }

    try {
      await axiosInstance.delete(`/api/v1/organizers/events/${eventId}`);
      toast.success("تم حذف الحدث بنجاح!");

      setEvents((prevEvents) =>
        prevEvents.filter((event) => event.id !== eventId)
      );
    } catch (error) {
      console.error("Error deleting event:", error);
      const errorMessage =
        error.response?.data?.detail || "حدث خطأ أثناء حذف الحدث.";

      toast.error(`${t("error_message")}: ${errorMessage}`);
    }
  };

  if (!eventDetail) {
    return <p>لا توجد تفاصيل متاحة</p>;
  }

  return (
    <div dir={languageDirection}>
      <style>
        {`
        .chat-bubble {
      padding: 12px 16px;
      border-radius: 20px;
      max-width: 75%;
      position: relative;
    }
    
    .other-bubble {
      background-color: #f1f3f5;
      color: #212529;
      border-top-left-radius: 4px;
    }
    
    .my-bubble {
      background-color: var(--bs-primary-custom, #0d6efd);
      color: white;
      border-top-right-radius: 4px;
    }
    
    .chat-bubble small {
      display: block;
      margin-top: 5px;
      font-size: 75%;
    }
    
    .my-bubble small {
      color: rgba(255, 255, 255, 0.7);
    }
    
    .chat-container::-webkit-scrollbar {
      width: 6px;
    }
    
    .chat-container::-webkit-scrollbar-track {
      background: #f1f1f1;
    }
    
    .chat-container::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 10px;
    }
    
    .chat-container::-webkit-scrollbar-thumb:hover {
      background: #999;
    }

        `}
      </style>

      <section className="py-5">
        <div className="container">
          {/* Header */}
          {eventDetail && (
            <div className="row mb-4">
              <div className="col-md-8">
                <h1 className="section-title">{eventDetail.name}</h1>
                <div className="d-flex flex-wrap align-items-center mb-3">
                  <div className="me-3 mb-2">
                    <i className="fas fa-calendar-alt text-primary-custom me-2"></i>
                    <span>
                      {moment(eventDetail.startDate).format("D MMM YYYY")} -{" "}
                      {moment(eventDetail.endDate).format("D MMM YYYY")}
                    </span>
                  </div>
                  <div className="me-3 mb-2">
                    <i className="fas fa-map-marker-alt text-primary-custom me-2"></i>
                    <span>{eventDetail.location || "بدون موقع"}</span>
                  </div>
                  <div className="me-3 mb-2">
                    <i className="fas fa-users text-primary-custom me-2"></i>
                    <span>{eventDetail.speakers_count} متحدثين</span>
                  </div>
                  <span
                    className={`badge ${
                      eventDetail.status === "upcoming"
                        ? "bg-success"
                        : "bg-secondary"
                    } me-3 mb-2`}
                  >
                    {t(eventDetail.status)}
                  </span>
                </div>

                {/* أزرار الإجراءات */}
                <div className="row mb-3">
                  <div className="col-md-3 col-sm-6 mb-2">
                    <button className="btn btn-outline-info w-100 h-100 py-2">
                      <i
                        className="fas fa-eye d-block mb-1"
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                      {t("preview")}
                    </button>
                  </div>
                  {/* اظهار المودل */}
                  {showModal && (
                    <InviteModal onClose={() => setShowModal(false)} />
                  )}
                  <div className="col-md-3 col-sm-6 mb-2">
                    <button
                      className="btn btn-primary w-100 h-100 py-2"
                      onClick={() => setShowModal(true)}
                    >
                      <i
                        className="fas fa-user-plus d-block mb-1"
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                      {t("invite")}
                    </button>
                  </div>
                  {/* ور التعديل */}
                  <div className="col-md-3 col-sm-6 mb-2">
                    <div>
                      <button
                        className="btn btn-warning w-100 h-100 py-2"
                        onClick={() => navigate(`/update-event/${eventId}`)}
                      >
                        <i
                          className="fas fa-edit d-block mb-1"
                          style={{ fontSize: "1.2rem" }}
                        ></i>
                        {t("update")}
                      </button>
                    </div>

                    {showEditPanel && selectedEvent && (
                      <EditEvent
                        key={selectedEvent?.id}
                        onClose={() => setShowEditPanel(false)}
                        initialData={selectedEvent}
                      />
                    )}
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2">
                    <button
                      className="btn btn-outline-danger w-100 h-100 py-2"
                      onClick={() => handleDelete(eventDetail.id)}
                    >
                      <i
                        className="fas fa-trash-alt d-block mb-1"
                        style={{ fontSize: "1.2rem" }}
                      ></i>
                      {t("delete")}
                    </button>
                  </div>
                </div>
              </div>

              {/* إحصائيات الحدث */}
              <div className="col-md-4 text-md-end">
                <div className="d-flex justify-content-end flex-wrap gap-3 mb-3">
                  <div className="text-center mx-2">
                    <span className="badge bg-success p-2">
                      {eventDetail.totalSpeakers || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("confirmed")}
                    </span>
                  </div>
                  <div className="text-center mx-2">
                    <span className="badge bg-warning text-dark p-2">
                      {eventDetail.totalPendingInvitations || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("invitations")}
                    </span>
                  </div>
                  <div className="text-center mx-2">
                    <span className="badge bg-info text-dark p-2">
                      {eventDetail.totalPendingRequests || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("requests")}
                    </span>
                  </div>
                  {/* <div className="text-center mx-2">
                    <span className="badge bg-danger p-2">
                      {eventDetail.totalRejectedRequests || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("rejected_requests")}
                    </span>
                  </div> */}
                  {/* <div className="text-center mx-2">
                    <span className="badge bg-secondary p-2">
                      {eventDetail.totalRejectedInvitations || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("rejected_invitations")}
                    </span>
                  </div> */}
                  <div className="text-center mx-2">
                    <span className="badge bg-dark p-2">
                      {eventDetail.totalSpecialities || 0}
                    </span>
                    <span className="d-block mt-1 small text-muted">
                      {t("specialities")}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Event Content */}
          <div className="row mb-4">
            <div className="col-12">
              <div className="card shadow-sm mb-4">
                <div className="card-img-top position-relative">
                  <img
                    src={eventDetail.bannerUrl}
                    className="img-fluid w-100"
                    alt={t("event_image_alt")}
                    style={{ maxHeight: "300px", objectFit: "cover" }}
                  />
                </div>
                <div className="card-body">
                  <h5 className="card-title" data-translate="about_event">
                    {t("about_event")}
                  </h5>
                  <p id="eventDescription">{eventDetail.details}</p>

                  <h5 className="card-title mt-4" data-translate="event_topics">
                    {t("event_topics")}
                  </h5>
                  <div className="d-flex flex-wrap mb-3">
                    {eventDetail.eventSpecialities.map((topic, index) => (
                      <span
                        key={index}
                        className="badge rounded-pill bg-light text-dark me-2 mb-2 p-2"
                      >
                        <i className={`${topic.icon} me-1`}></i>{" "}
                        {topic.arabicName}
                      </span>
                    ))}
                  </div>

                  <div className="card mt-4">
                    <div className="card-body bg-light">
                      <h6
                        className="card-title mb-3"
                        data-translate="event_details"
                      >
                        {t("event_details")}
                      </h6>
                      <div className="row">
                        <div className="col-md-6">
                          <ul className="list-unstyled">
                            <li className="mb-2">
                              <i className="fas fa-building text-primary-custom me-2"></i>
                              <strong data-translate="venue">
                                {t("venue")}:
                              </strong>{" "}
                              {eventDetail.city?.arabicName || "غير محدد"}
                            </li>
                            <li className="mb-2">
                              <i className="fas fa-clock text-primary-custom me-2"></i>
                              <strong data-translate="time">
                                {t("time")}:
                              </strong>{" "}
                              {new Date(eventDetail.eventOn).toLocaleString()}
                            </li>
                          </ul>
                        </div>
                        <div className="col-md-6">
                          <ul className="list-unstyled">
                            <li className="mb-2">
                              <i className="fas fa-users text-primary-custom me-2"></i>
                              <strong data-translate="expected_attendance">
                                {t("expected_attendance")}:
                              </strong>{" "}
                              {eventDetail.hoursDuration}
                            </li>
                            <li className="mb-2">
                              <i className="fas fa-globe text-primary-custom me-2"></i>
                              <strong data-translate="website">
                                {t("website")}:
                              </strong>
                              <a
                                href={eventDetail.link}
                                className="text-primary-custom"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t("website")}
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Event Timeline */}
                  {/* <div className="mt-4">
                    <h5 className="card-title" data-translate="event_timeline">
                      {t("event_timeline")}
                    </h5>
                    {eventDetail.eventInvitations.map((item, index) => (
                      <div key={index} className="mb-2 d-flex">
                        <div className="text-primary-custom me-2">
                          <i className="fas fa-check-circle"></i>
                        </div>
                        <div>
                          <strong>
                            {new Date(item.date).toLocaleString()}:
                          </strong>{" "}
                          {item.description}
                        </div>
                      </div>
                    ))}
                  </div> */}
                </div>
              </div>
            </div>
          </div>

          {/* Event Management Tabs */}
          <OrgnizerEventManagementTabs />
        </div>
        <ToastContainer />
      </section>
    </div>
  );
};

export default OrganizerEventDetail;
